<div class="root-container" (click)="show=!show">
  @if(!show){
      <i class="bi bi-eye-slash-fill"></i>
  } @else {
      <i class="bi bi-eye-fill"></i>
  }
</div>
